import { DialogTitle, IconButton } from '@mui/material';
import Grid from '@mui/material/Grid';
import { GridCloseIcon } from '@mui/x-data-grid-premium';

interface IDialogTitleProps {
  onClose: () => void;
  title: string;
}
const DialogTitleWithCloseButton: React.FC<IDialogTitleProps> = ({ onClose, title }) => {
  return (
    <>
      <DialogTitle variant="h6" component="h6">
        <Grid container justifyContent="space-between">
          <Grid
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: { xs: '75%', md: '90%' }, // or set your desired width, e.g., '200px'
            }}
          >
            {title}
          </Grid>
          <Grid sx={{ ml: 2 }}>
            <IconButton onClick={onClose}>
              <GridCloseIcon />
            </IconButton>{' '}
          </Grid>
        </Grid>
      </DialogTitle>
    </>
  );
};
export default DialogTitleWithCloseButton;
